import { Trans, useLingui } from '@lingui/react/macro';

import Stack from '@/design_system/Stack';
import InlineText from '@/design_system/Typography/InlineText';
import Paragraph from '@/design_system/Typography/Paragraph';
import IconStoreRepair from '@/icons/StoreRepair.svg';
import { BaseNotification } from '@/layouts/App/Navbar/NotificationList/components/BaseNotification/BaseNotification';
import type { TNotificationOfType } from '@/models/notification';

export const DispatchRefusedNotification = ({
  notification,
}: {
  notification: TNotificationOfType<'dispatch_refused'>;
}) => {
  const { t } = useLingui();

  return (
    <BaseNotification
      notificationLabel={t({
        id: 'notification.dispatch-refused.label',
        message: `${notification.data.workshopName} has refused the job for request ${notification.request.reference}, you need to dispatch it to another workshop`,
      })}
      icon={<IconStoreRepair />}
      type="warning"
      notification={notification}
      notificationHeader={(color) => (
        <Trans id="notification.dispatch-refused">
          <InlineText weight="medium" color={color}>
            {notification.data.workshopName}
          </InlineText>{' '}
          has refused the job, you need to dispatch it to another workshop.
        </Trans>
      )}
      notificationContent={
        <Stack
          className="bg-neutral-100"
          style={{
            padding: '8px 12px',
            borderRadius: '0.5rem',
          }}
        >
          <Paragraph
            style={{
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}
          >
            {notification.data.refusalReason}
          </Paragraph>
        </Stack>
      }
    />
  );
};
